import React from 'react';
import {
    ChipField,
    Datagrid,
    Filter,
    List,
    ReferenceArrayField,
    SingleFieldList,
    TextField,
    TextInput
} from 'react-admin';

const MerchantGroupFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const MerchantGroupList = props => (
    <List filters={<MerchantGroupFilter/>} {...props} exporter={false}>
        <Datagrid rowClick={"edit"}>
            <TextField source="name"/>
            <ReferenceArrayField reference="merchants" source="merchantIds">
                <SingleFieldList>
                    <ChipField source="name"/>
                </SingleFieldList>
            </ReferenceArrayField>
        </Datagrid>
    </List>
);

export default MerchantGroupList
